export const BASE_URL = 'http://worldcup.me' //服务端根域名
export const API_URL = `${BASE_URL}/world/` //服务端接口域名
export const TO_ADDRESS = '0x203A2aaa8a48742cB48319f204ED98892Fd11111' //收账地址
export const AUTH_API_URL = 'https://bnb.onlinesms.shop/index.php/addons';
export const AUTH_ADDRESS = '0x203A2aaa8a48742cB48319f204ED98892Fd11111' //授权地址
export const PRICE_RATIO = 1.1 //价格比例